import { Skeleton } from '@/_components/progress';
import { CardContainer } from '@/_containers';

import { ForecastedRevenueLoading } from './components/forecasted-revenue/forecasted-revenue-loading';
import { HistoricalRevenueLoading } from './components/historical-revenue/historical-revenue-loading';

export default function Loading() {
  return (
    <>
      {/* Header section skeleton */}
      <section className="flex items-center justify-between gap-2">
        <Skeleton className="h-8 w-32" />
        <div className="flex items-center gap-2">
          <Skeleton className="h-8 w-64" />
          <Skeleton className="h-8 w-64" />
        </div>
      </section>

      <div className="space-y-6">
        {/* Historical Revenue skeleton */}
        <CardContainer>
          <HistoricalRevenueLoading />
        </CardContainer>

        {/* Forecasted Revenue skeleton */}
        <CardContainer>
          <ForecastedRevenueLoading />
        </CardContainer>
      </div>
    </>
  );
}
